import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import AsyncDropDownFilter from '../../../components/filters/asyncDropdownFilter';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FcViewDetails } from "react-icons/fc";

import { DataContext } from '../../../init/getData';


import ViewModal from '../../../components/modals/viewModal';





function CustomerPrice(props) {



  const { api, userData, categoryOptions, yearId, companyId, defaultCurrency, allUserOptions, customerAccountData,
    mainCurrency, refData, loadProductOptions, productOptions, branchOptions, contentLanguages } = useContext(DataContext);



  const table = 'customerPrice';
  const title = 'Customer Price';

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch', 'category', 'product', 'user', 'customerAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today });



  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);


  // Account Options
  const accountOptions = customerAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english + ' [' + item.phone + ']',
  }));
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };


  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => {
      return {
        Barcode: item.product?.barcode || '',
        Name: item.product?.name || '',
        Account: item.account?.english || item.transaction?.journalVoucher?.account?.english || '',
        Price: item.price || item.totalPrice || 0,
        Currency: item.currency?.code || '',
        "Last Modified": item.modifiedAt || '',
        "Modified By": item.modifiedBy?.name || '',
   
      };
    });
  
    return { transformedData };
  };
  

  const accountIdView = (id, record) => {
    if (record.parentId) {
      return <>{record.parent?.accountId + '.' + record.accountId}</>
    } else {
      return <>{record.accountId}</>  
    }
  }

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.barcode, dataIndex: 'product', render: (product) => (product?.barcode) },
    { title: contentLanguages.Name, dataIndex: 'product', render: (product) => (product?.name) },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english) },
    { title: contentLanguages.Price, dataIndex: 'price' },
    { title: contentLanguages.Currency, dataIndex: 'currency', render: (currency) => (currency?.code) },
    { title: contentLanguages.LastModified, dataIndex: 'modifiedAt', render: dateTableFormatter },
    { title: contentLanguages.ModifiedBy, dataIndex: 'modifiedBy', render: (modifiedBy) => (modifiedBy?.name) },

  ], []);


  const tableFooter = (
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
    </div>
  )



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Category...'}
                value={categoryOptions?.find(option => option.value === filter.categoryId)}
                onChange={(e) => handleSelectChange(e, 'categoryId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadProductOptions}
                isSearchable
                placeholder={'Select Product...'}
                value={productOptions?.find(option => option.value === filter.productId)}
                onChange={(e) => handleSelectChange(e, 'productId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadAccountOptions}
                isSearchable
                placeholder={'Select Customer...'}
                value={accountOptions?.find(option => option.value === filter.accountId)}
                onChange={(e) => handleSelectChange(e, 'accountId')}
              />
            </Col>

            <Col md={2}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>





          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucherId={idRow?.transaction?.journalVoucher?.id}
          />



        </div>
      }


    </div>
  )
}

export default CustomerPrice;
